import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "tabs_tn1",
  class: "tabs_tn"
}
const _hoisted_2 = { class: "wrap_tn" }
const _hoisted_3 = { class: "on_tn on_choose" }
const _hoisted_4 = { class: "it_3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)
const _hoisted_6 = {
  key: 0,
  class: "it_3 it_ccc"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)
const _hoisted_8 = {
  key: 1,
  class: "it_3 it_ccc"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "A3. Giới tính ", -1)
const _hoisted_10 = { class: "ps" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "nam",
  style: {"margin-right":"60px"}
}, " Nam", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "nu" }, " Nữ", -1)
const _hoisted_13 = {
  key: 2,
  class: "it_3 it_ccc"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khách hàng gởi", -1)
const _hoisted_15 = {
  class: "flex align-items-center",
  style: {"width":"40px","alignment":"center"}
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { style: {"width":"40px","alignment":"top"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("small", {
  id: "id-note1",
  class: "p-error"
}, "* Vui lòng chọn danh sách khách hàng gởi", -1)
const _hoisted_19 = {
  key: 3,
  class: "it_3 it_ccc"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", null, null, -1)
const _hoisted_21 = {
  key: 4,
  class: "it_3 it_ccc"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)
const _hoisted_23 = { class: "it_full" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn", -1)
const _hoisted_25 = { class: "it_bt" }
const _hoisted_26 = {
  id: "tabs_tn2",
  class: "tabs_tn"
}
const _hoisted_27 = { class: "wrap_tn" }
const _hoisted_28 = { class: "on_tn on_choose" }
const _hoisted_29 = { class: "it_3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)
const _hoisted_31 = {
  key: 0,
  class: "it_3 it_ccc"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)
const _hoisted_33 = {
  key: 1,
  class: "it_3 it_ccc"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)
const _hoisted_35 = {
  key: 2,
  class: "it_3 it_ccc"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "A3. Giới tính ", -1)
const _hoisted_37 = { class: "ps" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "nam",
  style: {"margin-right":"60px"}
}, " Nam", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "nu" }, " Nữ", -1)
const _hoisted_40 = {
  key: 3,
  class: "it_3 it_ccc"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khách hàng gởi", -1)
const _hoisted_42 = {
  class: "flex align-items-center",
  style: {"width":"40px","alignment":"center"}
}
const _hoisted_43 = ["src"]
const _hoisted_44 = { style: {"width":"40px","alignment":"top"} }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("small", {
  id: "id-note2",
  class: "p-error"
}, "* Vui lòng chọn danh sách khách hàng gởi", -1)
const _hoisted_46 = {
  key: 4,
  class: "it_3 it_ccc"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h5", null, null, -1)
const _hoisted_48 = { class: "pannel_tk" }
const _hoisted_49 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_50 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_51 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_52 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của khung chính", -1)
const _hoisted_54 = {
  key: 0,
  class: "p-error"
}
const _hoisted_55 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung khung chính", -1)
const _hoisted_57 = {
  key: 0,
  class: "p-error"
}
const _hoisted_58 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh chính", -1)
const _hoisted_60 = { class: "p-inputgroup" }
const _hoisted_61 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn khung chính", -1)
const _hoisted_63 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_64 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_65 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_66 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 1", -1)
const _hoisted_68 = {
  key: 0,
  class: "p-error"
}
const _hoisted_69 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 1", -1)
const _hoisted_71 = { class: "p-inputgroup" }
const _hoisted_72 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 1", -1)
const _hoisted_74 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 1", -1)
const _hoisted_76 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 1", -1)
const _hoisted_78 = {
  key: 0,
  class: "p-error"
}
const _hoisted_79 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 1", -1)
const _hoisted_81 = {
  key: 0,
  class: "p-error"
}
const _hoisted_82 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 1", -1)
const _hoisted_84 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_85 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 2", -1)
const _hoisted_87 = {
  key: 0,
  class: "p-error"
}
const _hoisted_88 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 2", -1)
const _hoisted_90 = { class: "p-inputgroup" }
const _hoisted_91 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 2", -1)
const _hoisted_93 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 2", -1)
const _hoisted_95 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 2", -1)
const _hoisted_97 = {
  key: 0,
  class: "p-error"
}
const _hoisted_98 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 2", -1)
const _hoisted_100 = {
  key: 0,
  class: "p-error"
}
const _hoisted_101 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 2", -1)
const _hoisted_103 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_104 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 3", -1)
const _hoisted_106 = {
  key: 0,
  class: "p-error"
}
const _hoisted_107 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 3", -1)
const _hoisted_109 = { class: "p-inputgroup" }
const _hoisted_110 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 3", -1)
const _hoisted_112 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 3", -1)
const _hoisted_114 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 3", -1)
const _hoisted_116 = {
  key: 0,
  class: "p-error"
}
const _hoisted_117 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 3", -1)
const _hoisted_119 = {
  key: 0,
  class: "p-error"
}
const _hoisted_120 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 3", -1)
const _hoisted_122 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_123 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 4", -1)
const _hoisted_125 = {
  key: 0,
  class: "p-error"
}
const _hoisted_126 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 4", -1)
const _hoisted_128 = { class: "p-inputgroup" }
const _hoisted_129 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 4", -1)
const _hoisted_131 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 4", -1)
const _hoisted_133 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 4", -1)
const _hoisted_135 = {
  key: 0,
  class: "p-error"
}
const _hoisted_136 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 4", -1)
const _hoisted_138 = {
  key: 0,
  class: "p-error"
}
const _hoisted_139 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 4", -1)
const _hoisted_141 = { class: "bt_gtn" }
const _hoisted_142 = { class: "tum_lunm" }
const _hoisted_143 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_144 = { id: "loading" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", null, "Đang gởi tin nhắn, vui lòng chờ ...", -1)
const _hoisted_146 = { class: "p-field p-col-10 p-sm-10 p-md-10" }
const _hoisted_147 = { class: "card" }
const _hoisted_148 = { class: "p-field p-col-10 p-sm-10 p-md-10" }
const _hoisted_149 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_150 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_151 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_152 = { class: "p-field p-col-4 p-sm-4 p-md-3" }
const _hoisted_153 = { enctype: "multipart/form-data" }
const _hoisted_154 = ["disabled"]
const _hoisted_155 = { class: "col-12 md:col-4" }
const _hoisted_156 = { class: "product-grid-item card" }
const _hoisted_157 = {
  class: "product-grid-item-content",
  style: {"margin":"10px"}
}
const _hoisted_158 = ["src", "onClick"]
const _hoisted_159 = {
  class: "product-name",
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TabView, null, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { header: "Gởi tin nhắn thông thường" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_Dropdown, {
                      id: "kind",
                      modelValue: $setup.action,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.action) = $event)),
                      options: $setup.lsAction,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  ($setup.action == 'location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_Dropdown, {
                          id: "location",
                          modelValue: $setup.province,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.province) = $event)),
                          options: $setup.listProvince,
                          optionLabel: "provinceName",
                          optionValue: "provinceCode",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'gender')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nam",
                            name: "sex",
                            value: "Nam",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.gender) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender]
                          ]),
                          _hoisted_11,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nu",
                            name: "sex",
                            value: "Nữ",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.gender) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender]
                          ]),
                          _hoisted_12
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'customer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_MultiSelect, {
                          modelValue: $setup.listIdMessage,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.listIdMessage) = $event)),
                          options: $setup.listCustomer,
                          optionLabel: "name",
                          placeholder: "Chọn tài khoản",
                          filter: true,
                          style: {"height":"35px"}
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_15, [
                              (slotProps.option.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: slotProps.option.imageUrl,
                                    style: {"width":"40px","margin-right":"3px"}
                                  }, null, 8, _hoisted_16))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_17, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]),
                        _hoisted_18
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'age')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age), 1),
                        _hoisted_20,
                        _createVNode(_component_Slider, {
                          modelValue: $setup.age,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.age) = $event)),
                          range: true
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_Dropdown, {
                          id: "group",
                          modelValue: $setup.idGroup,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.idGroup) = $event)),
                          options: $setup.listGroup,
                          optionLabel: "groupName",
                          optionValue: "id",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Textarea, {
                      id: "message",
                      type: "text",
                      modelValue: $setup.message.mess,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.message.mess) = $event)),
                      style: {"height":"100px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Button, {
                      style: {"margin-top":"3px"},
                      label: "Gởi tin nhắn",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.doSendMessage())),
                      disabled: !$setup.valid()
                    }, null, 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Gởi tin nhắn theo mẫu đính kèm" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_Dropdown, {
                      id: "kind2",
                      modelValue: $setup.action2,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.action2) = $event)),
                      options: $setup.lsAction,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  ($setup.action == 'location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_Dropdown, {
                          id: "location2",
                          modelValue: $setup.province2,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.province2) = $event)),
                          options: $setup.listProvince,
                          optionLabel: "provinceName",
                          optionValue: "provinceCode",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_Dropdown, {
                          id: "group2",
                          modelValue: $setup.idGroup2,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.idGroup2) = $event)),
                          options: $setup.listGroup,
                          optionLabel: "groupName",
                          optionValue: "id",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'gender')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nam2",
                            name: "sex",
                            value: "Nam",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.gender2) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender2]
                          ]),
                          _hoisted_38,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nu2",
                            name: "sex",
                            value: "Nữ",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.gender2) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender2]
                          ]),
                          _hoisted_39
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'customer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createVNode(_component_MultiSelect, {
                          modelValue: $setup.listId,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.listId) = $event)),
                          options: $setup.listCustomer,
                          optionLabel: "name",
                          placeholder: "Chọn tài khoản",
                          filter: true,
                          style: {"height":"35px"}
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_42, [
                              (slotProps.option.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: slotProps.option.imageUrl,
                                    style: {"width":"40px","margin-right":"3px"}
                                  }, null, 8, _hoisted_43))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_44, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]),
                        _hoisted_45
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'age')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age2), 1),
                        _hoisted_47,
                        _createVNode(_component_Slider, {
                          modelValue: $setup.age2,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.age2) = $event)),
                          range: true
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_Panel, { header: "Thiết kế khung chính của tin nhắn" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _hoisted_53,
                              _createVNode(_component_Textarea, {
                                id: "titleMain",
                                type: "text",
                                modelValue: $setup.element1.title,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.element1.title) = $event))
                              }, null, 8, ["modelValue"]),
                              ($setup.element1.title?.length > 0)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_54, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element1.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createVNode(_component_Textarea, {
                                id: "subtitleMain",
                                type: "text",
                                modelValue: $setup.element1.subtitle,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.element1.subtitle) = $event)),
                                autoResize: "",
                                rows: "10"
                              }, null, 8, ["modelValue"]),
                              ($setup.element1.subtitle?.length > 0)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_57, "Nội dung đang có độ dài " + _toDisplayString($setup.element1.subtitle?.length) + " ký tự (tối đa 500 ký tự).", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _hoisted_59,
                              _createElementVNode("div", _hoisted_60, [
                                _createVNode(_component_Textarea, {
                                  id: "imageUrlMain",
                                  type: "text",
                                  modelValue: $setup.element1.image_url,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.element1.image_url) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_Button, {
                                  label: "chọn hình",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.showListImage(1)))
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createVNode(_component_Textarea, {
                                id: "defaultUrl",
                                type: "text",
                                modelValue: $setup.element1.url,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.element1.url) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Panel, { header: "Thiết kế thành phần" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_Accordion, {
                            multiple: true,
                            activeIndex: [0,1]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AccordionTab, { header: "Tham số 1" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("div", _hoisted_66, [
                                      _hoisted_67,
                                      _createVNode(_component_InputText, {
                                        id: "title1",
                                        type: "text",
                                        modelValue: $setup.element2.title,
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.element2.title) = $event))
                                      }, null, 8, ["modelValue"]),
                                      ($setup.element2.title?.length > 0)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_68, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element2.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      _hoisted_70,
                                      _createElementVNode("div", _hoisted_71, [
                                        _createVNode(_component_InputText, {
                                          id: "imageUrl1",
                                          type: "text",
                                          modelValue: $setup.element2.image_url,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.element2.image_url) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_Button, {
                                          label: "chọn hình",
                                          onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.showListImage(2)))
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_72, [
                                      _hoisted_73,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: $setup.element2.type,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.element2.type) = $event)),
                                        options: $setup.list,
                                        optionLabel: "label",
                                        optionValue: "param",
                                        showClear: "true"
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    ($setup.element2.type == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                          _hoisted_75,
                                          _createVNode(_component_InputText, {
                                            id: "defaultUrl1",
                                            type: "text",
                                            modelValue: $setup.element2.url,
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.element2.url) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element2.type == 2)||($setup.element2.type == 3))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          _hoisted_77,
                                          _createVNode(_component_InputText, {
                                            id: "automessage",
                                            type: "text",
                                            modelValue: $setup.element2.payload,
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.element2.payload) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.element2.payload?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_78, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element2.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.element2.type == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                          _hoisted_80,
                                          _createVNode(_component_InputText, {
                                            id: "smscontent",
                                            type: "text",
                                            modelValue: $setup.payload1.content,
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.payload1.content) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.payload1.content?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_81, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload1.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element2.type == 4)||($setup.element2.type == 5))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                          _hoisted_83,
                                          _createVNode(_component_InputMask, {
                                            mask: "(9999)999999",
                                            modelValue: $setup.payload1.phone_code,
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.payload1.phone_code) = $event)),
                                            placeholder: ""
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_AccordionTab, { header: "Tham số 2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("div", _hoisted_85, [
                                      _hoisted_86,
                                      _createVNode(_component_InputText, {
                                        id: "title2",
                                        type: "text",
                                        modelValue: $setup.element3.title,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.element3.title) = $event))
                                      }, null, 8, ["modelValue"]),
                                      ($setup.element3.title?.length > 0)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_87, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element3.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_88, [
                                      _hoisted_89,
                                      _createElementVNode("div", _hoisted_90, [
                                        _createVNode(_component_InputText, {
                                          id: "imageUrl2",
                                          type: "text",
                                          modelValue: $setup.element3.image_url,
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.element3.image_url) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_Button, {
                                          label: "chọn hình",
                                          onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.showListImage(3)))
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_91, [
                                      _hoisted_92,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: $setup.element3.type,
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.element3.type) = $event)),
                                        options: $setup.list,
                                        optionLabel: "label",
                                        optionValue: "param",
                                        showClear: "true"
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    ($setup.element3.type == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                          _hoisted_94,
                                          _createVNode(_component_InputText, {
                                            id: "defaultUrl2",
                                            type: "text",
                                            modelValue: $setup.element3.url,
                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.element3.url) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element3.type == 2)||($setup.element3.type == 3))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                          _hoisted_96,
                                          _createVNode(_component_InputText, {
                                            id: "automessage2",
                                            type: "text",
                                            modelValue: $setup.element3.payload,
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.element3.payload) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.element3.payload?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_97, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element3.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.element3.type == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                          _hoisted_99,
                                          _createVNode(_component_InputText, {
                                            id: "smscontent2",
                                            type: "text",
                                            modelValue: $setup.payload2.content,
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.payload2.content) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.payload2.content?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_100, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload2.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element3.type == 4)||($setup.element3.type == 5))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                          _hoisted_102,
                                          _createVNode(_component_InputMask, {
                                            mask: "(9999)999999",
                                            modelValue: $setup.payload2.phone_code,
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.payload2.phone_code) = $event)),
                                            placeholder: ""
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_AccordionTab, { header: "Tham số 3" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_103, [
                                    _createElementVNode("div", _hoisted_104, [
                                      _hoisted_105,
                                      _createVNode(_component_InputText, {
                                        id: "title3",
                                        type: "text",
                                        modelValue: $setup.element4.title,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.element4.title) = $event))
                                      }, null, 8, ["modelValue"]),
                                      ($setup.element4.title?.length > 0)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_106, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element4.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_107, [
                                      _hoisted_108,
                                      _createElementVNode("div", _hoisted_109, [
                                        _createVNode(_component_InputText, {
                                          id: "imageUrl3",
                                          type: "text",
                                          modelValue: $setup.element4.image_url,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.element4.image_url) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_Button, {
                                          label: "chọn hình",
                                          onClick: _cache[39] || (_cache[39] = ($event: any) => ($setup.showListImage(4)))
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_110, [
                                      _hoisted_111,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: $setup.element4.type,
                                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.element4.type) = $event)),
                                        options: $setup.list,
                                        optionLabel: "label",
                                        optionValue: "param",
                                        showClear: "true"
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    ($setup.element4.type == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                          _hoisted_113,
                                          _createVNode(_component_InputText, {
                                            id: "defaultUrl3",
                                            type: "text",
                                            modelValue: $setup.element4.url,
                                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.element4.url) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element4.type == 2)||($setup.element4.type == 3))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                          _hoisted_115,
                                          _createVNode(_component_InputText, {
                                            id: "automessage3",
                                            type: "text",
                                            modelValue: $setup.element4.payload,
                                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.element4.payload) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.element4.payload?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_116, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element4.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.element4.type == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                          _hoisted_118,
                                          _createVNode(_component_InputText, {
                                            id: "smscontent3",
                                            type: "text",
                                            modelValue: $setup.payload3.content,
                                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.payload3.content) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.payload3.content?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_119, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload3.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element4.type == 4)||($setup.element4.type == 5))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                          _hoisted_121,
                                          _createVNode(_component_InputMask, {
                                            mask: "(9999)999999",
                                            modelValue: $setup.payload3.phone_code,
                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.payload3.phone_code) = $event)),
                                            placeholder: ""
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_AccordionTab, { header: "Tham số 4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_122, [
                                    _createElementVNode("div", _hoisted_123, [
                                      _hoisted_124,
                                      _createVNode(_component_InputText, {
                                        id: "title4",
                                        type: "text",
                                        modelValue: $setup.element5.title,
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.element5.title) = $event))
                                      }, null, 8, ["modelValue"]),
                                      ($setup.element5.title?.length > 0)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_125, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element5.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_126, [
                                      _hoisted_127,
                                      _createElementVNode("div", _hoisted_128, [
                                        _createVNode(_component_InputText, {
                                          id: "imageUrl4",
                                          type: "text",
                                          modelValue: $setup.element5.image_url,
                                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.element5.image_url) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_Button, {
                                          label: "chọn hình",
                                          onClick: _cache[47] || (_cache[47] = ($event: any) => ($setup.showListImage(5)))
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_129, [
                                      _hoisted_130,
                                      _createVNode(_component_Dropdown, {
                                        modelValue: $setup.element5.type,
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (($setup.element5.type) = $event)),
                                        options: $setup.list,
                                        optionLabel: "label",
                                        optionValue: "param",
                                        showClear: "true"
                                      }, null, 8, ["modelValue", "options"])
                                    ]),
                                    ($setup.element5.type == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                          _hoisted_132,
                                          _createVNode(_component_InputText, {
                                            id: "defaultUrl4",
                                            type: "text",
                                            modelValue: $setup.element5.url,
                                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (($setup.element5.url) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element5.type == 2)||($setup.element5.type == 3))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                          _hoisted_134,
                                          _createVNode(_component_InputText, {
                                            id: "automessage4",
                                            type: "text",
                                            modelValue: $setup.element5.payload,
                                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (($setup.element5.payload) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.element5.payload?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_135, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element5.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($setup.element5.type == 4)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                          _hoisted_137,
                                          _createVNode(_component_InputText, {
                                            id: "smscontent4",
                                            type: "text",
                                            modelValue: $setup.payload4.content,
                                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.payload4.content) = $event))
                                          }, null, 8, ["modelValue"]),
                                          ($setup.payload4.content?.length > 0)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_138, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload4.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (($setup.element5.type == 4)||($setup.element5.type == 5))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                          _hoisted_140,
                                          _createVNode(_component_InputMask, {
                                            mask: "(9999)999999",
                                            modelValue: $setup.payload4.phone_code,
                                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.payload4.phone_code) = $event)),
                                            placeholder: ""
                                          }, null, 8, ["modelValue"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_141, [
                    _createVNode(_component_Button, {
                      style: {"margin-top":"10px"},
                      label: "Gởi tin nhắn",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => ($setup.doSendMessageWithAttachment())),
                      disabled: !$setup.valid2()
                    }, null, 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_142, [
      _createElementVNode("div", _hoisted_143, [
        _createVNode(_component_Dialog, {
          header: "Gởi tin nhắn",
          visible: $setup.loadingBar,
          "onUpdate:visible": _cache[54] || (_cache[54] = ($event: any) => (($setup.loadingBar) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_144, [
              _hoisted_145,
              _createVNode(_component_ProgressBar, {
                mode: "indeterminate",
                style: {"height":".3em"}
              })
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_ConfirmDialog)
      ]),
      _createElementVNode("div", _hoisted_146, [
        _createElementVNode("div", _hoisted_147, [
          _createElementVNode("div", _hoisted_148, [
            _createVNode(_component_Dialog, {
              header: "Tập tin lưu trên máy chủ",
              visible: $setup.show,
              "onUpdate:visible": _cache[58] || (_cache[58] = ($event: any) => (($setup.show) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("div", _hoisted_150, [
                    _createVNode(_component_InputText, {
                      id: "find",
                      type: "text",
                      modelValue: $setup.find,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (($setup.find) = $event)),
                      onInput: _cache[56] || (_cache[56] = ($event: any) => ($setup.search($event))),
                      placeholder: "Tìm kiếm"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_151, [
                    _createVNode(_component_Button, {
                      label: "Xóa hình",
                      onClick: $setup.deleteImage,
                      icon: "pi pi-trash",
                      style: {"margin-right":"5vw"},
                      disabled: !$setup.validImageSelect()
                    }, null, 8, ["onClick", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("form", _hoisted_153, [
                      _createElementVNode("input", {
                        id: "myFile",
                        type: "file",
                        style: {"display":"none"},
                        accept: ".jpeg,.png,.jpg",
                        name: "files",
                        multiple: "multiple",
                        onChange: _cache[57] || (_cache[57] = ($event: any) => (_ctx.fileChange($event.target.files))),
                        disabled: $setup.loadingBar
                      }, null, 40, _hoisted_154)
                    ])
                  ])
                ]),
                _createVNode(_component_DataView, {
                  value: $setup.listImageFull,
                  layout: $setup.layout,
                  paginator: true,
                  rows: 20,
                  sortOrder: _ctx.sortOrder,
                  sortField: _ctx.sortField
                }, {
                  grid: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_155, [
                      _createElementVNode("div", _hoisted_156, [
                        _createElementVNode("div", _hoisted_157, [
                          _createVNode(_component_Card, null, {
                            content: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "imageupload",
                                src: slotProps.data.link,
                                onClick: ($event: any) => ($setup.imageClick(slotProps.data.link))
                              }, null, 8, _hoisted_158),
                              _createElementVNode("div", _hoisted_159, _toDisplayString(slotProps.data.fileName), 1),
                              _createVNode(_component_Checkbox, {
                                modelValue: slotProps.data.delete,
                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.delete) = $event),
                                binary: true
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "layout", "sortOrder", "sortField"])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ], 64))
}